var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIsoLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "3.962 4.294 8.472 4.884 5.398 9.32 3.962 4.294",
    opacity: 0.33,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,0H10L0,2V13l5,3H6l10-2V3Zm0,1.1662,3.51,2.1062L11,3.985ZM10,1.02V4.188l-1.0225.2076L3.5549,3.6864,1.6862,2.6826Zm0,4.1763V10l-4,.8038V9.5L8.8189,5.4335ZM5,14.8338,1.49,12.7275,5,12.015Zm0-3.829-4,.8039V3.3711L3.3792,4.6745,5,10.3487Zm.5016-2.541L4.4587,4.8131l3.2764.4285ZM6,14.98V11.812L10,11l4.3217,2.3159Zm9-2.3565-4-2.1862V4.9951l4-.8039Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIsoLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/iso-left.041ca11d34ec97863f5b4ded04fdccf4.svg";